// Comportements de la fiche entreprise (maquette « Entreprise Sofruce - 30 sept ») :
// - frise de l'histoire remplie au fil du défilement (progression --anima-frise-p de 0 à 1,
//   jalon dépassé = is-on) ; écoute du défilement seulement frise à l'écran ; pleine sans JS
//   ou avec la réduction des animations ;
// - bouton flottant « Nous contacter » : visible une fois les chiffres passés au-dessus de
//   l'écran, monogramme qui tourne avec le défilement (0,4° par pixel, coupé si animations
//   réduites).

const FRISE_START = 0.8 // part de la hauteur d'écran où le remplissage commence
const FRISE_EXTRA = 0.3 // course supplémentaire (en hauteur d'écran) après la frise
const ROTATION = 0.4 // degrés par pixel défilé
const HALF = 2
const DECIMALS = 3 // précision de la progression écrite dans le style

const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches
const clamp01 = (v) => Math.min(1, Math.max(0, v))

const initFrise = (wrap) => {
  if (reduced() || !('IntersectionObserver' in window)) {
    return
  }
  const jalons = [...wrap.querySelectorAll('.anima-frise-jalon')]
  const vertical = () => window.matchMedia('(max-width: 991.98px)').matches
  let frame = 0
  wrap.classList.add('is-pending')

  const render = () => {
    frame = 0
    const vh = window.innerHeight
    const r = wrap.getBoundingClientRect()
    const p = clamp01((FRISE_START * vh - r.top) / (r.height + FRISE_EXTRA * vh))
    wrap.style.setProperty('--anima-frise-p', p.toFixed(DECIMALS))
    jalons.forEach((j) => {
      const dot = j.querySelector('.anima-frise-dot').getBoundingClientRect()
      const front = vertical() ? r.top + p * r.height : r.left + p * r.width
      const center = vertical() ? dot.top + dot.height / HALF : dot.left + dot.width / HALF
      j.classList.toggle('is-on', front >= center)
    })
  }
  const onScroll = () => {
    if (!frame) {
      frame = requestAnimationFrame(render)
    }
  }
  new IntersectionObserver(([en]) => {
    if (en.isIntersecting) {
      window.addEventListener('scroll', onScroll, {
        passive: true
      })
      onScroll()
    } else {
      window.removeEventListener('scroll', onScroll)
    }
  }).observe(wrap)
  render()
}

const initFlottant = (btn) => {
  const repere = document.getElementById('chiffres')
  if (repere && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      btn.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.bottom < 0)
    }).observe(repere)
  } else {
    btn.classList.add('is-on')
  }
  if (reduced() || !btn.querySelector('.anima-flottant-mono')) {
    return
  }
  let frame = 0
  window.addEventListener('scroll', () => {
    if (!frame) {
      frame = requestAnimationFrame(() => {
        frame = 0
        btn.style.setProperty('--anima-flottant-r', `${(window.scrollY * ROTATION).toFixed(1)}deg`)
      })
    }
  }, {
    passive: true
  })
}

const init = () => {
  document.querySelectorAll('[data-anima-frise]').forEach(initFrise)
  document.querySelectorAll('[data-anima-flottant]').forEach(initFlottant)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
